import { merge } from './utils/merge';
import { generateWJTags, generatorErrorTags } from './utils/tags';
import { isNull, isNotEmptyObject, isError } from './utils/check';
import { SDK_VERSION } from './version';
import { ERROR_PAYLOAD_ATTR } from './utils/tags';
import { generateOption, prepareSendHook, prepareFilterHook } from './utils/generate-option';
var preSendHook;
var preFilterHook;
var isSetup = false;
export function _setup(Sentry, options, defaultOptions) {
    if (isSetup)
        return;
    var defaultSdkOptions = {
        tracesSampleRate: 1,
        wjTags: {
            tracker_sdk_version: "v" + SDK_VERSION
        },
        /**
         * 数据发送前最后处理的地方
         * return null 则直接过滤掉消息
         * return event 正常发送
         */
        beforeSend: function (event, hint) {
            if (isNull(preSendHook(event, hint))) {
                console.warn('hit beforeSend will ignore this error!');
                return null;
            }
            if (preFilterHook(hint)) {
                console.warn('hit filter will ignore this error!');
                return null;
            }
            generatorErrorTags(event, hint);
            return event;
        }
    };
    /* 参数验证 */
    options = generateOption(options);
    if (!isNotEmptyObject(options)) {
        console.error('无效的配置, 监控将不生效！');
        return;
    }
    /* 合并参数 */
    try {
        /* 本处将 提取,合并和删除 配置中 beforeSend 参数 */
        preSendHook = prepareSendHook(options, defaultOptions);
        var mergeOptions = Object.create(null);
        if (defaultOptions && isNotEmptyObject(defaultOptions)) {
            mergeOptions = merge(options, defaultOptions);
        }
        mergeOptions = merge(mergeOptions, defaultSdkOptions);
        preFilterHook = prepareFilterHook(options);
        /* 初始化 */
        Sentry.init(mergeOptions);
        /* 提取模块名参数 */
        var tags = generateWJTags(mergeOptions, true);
        /* 设置全局tag数据 */
        _setTags(Sentry, tags);
        isSetup = true;
    }
    catch (e) {
        console.error('tracker sdk [setup] error', e);
    }
}
export function _send(Sentry, error, extra) {
    try {
        if (!isError(error)) {
            error = new Error(error);
        }
        error[ERROR_PAYLOAD_ATTR] = extra;
        Sentry.captureException(error);
    }
    catch (e) {
        console.error('tracker sdk [send] error', e);
    }
}
export function _addTags(Sentry, tagsOrigin) {
    if (!isNotEmptyObject(tagsOrigin))
        return;
    try {
        /* 提取模块名参数 */
        var tags = generateWJTags({
            wjTags: tagsOrigin
        });
        /* 设置全局tag数据 */
        _setTags(Sentry, tags);
    }
    catch (e) {
        console.error('tracker sdk [close] error', e);
    }
}
function _setTags(Sentry, tags) {
    if (isNotEmptyObject(tags)) {
        Sentry.setTags(tags);
    }
}
export function _close(Sentry, time) {
    isSetup = false;
    try {
        return Sentry.close(time);
    }
    catch (e) {
        console.error('tracker sdk [close] error', e);
    }
}
export { SDK_VERSION };
//# sourceMappingURL=sdk.js.map